<template>
  <div>
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="width: 50px; height: 50px"
    >
      <path
        class="fillCls1"
        d="M135.102 111.271C129.004 103.803 123.277 83.8065 118.922 74.1403C114.567 64.4742 107.472 47.7954 103.24 41.6973C99.0084 35.5991 89.0503 25.6423 84.0101 24.3972C78.9699 23.1521 75.4855 31.4909 79.5925 37.8385C83.6995 44.1862 92.6047 54.8055 90.7932 64.8472C90.7932 64.8472 49.4724 22.9039 42.1292 13.073C34.786 3.24214 27.9418 0.749498 23.71 3.61267C19.4783 6.47585 18.5214 12.7848 43.2695 46.594L50.5927 105.771C50.5927 105.771 59.181 115.136 65.1544 120.493C71.1277 125.85 86.4379 139.659 93.2833 147.5C93.2833 147.5 100.75 135.179 110.707 126.715C120.664 118.252 135.102 111.271 135.102 111.271Z"
        fill="#FEB0A3"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls4"
        d="M62.0097 36.8501H52.7402V55.8281H62.0097V36.8501Z"
        fill="#127EFF"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls6"
        d="M48.7559 38.7146C48.3463 38.714 47.9509 38.5641 47.6438 38.293C47.3367 38.0218 47.1389 37.6481 47.0875 37.2417C47.0361 36.8352 47.1346 36.424 47.3646 36.085C47.5945 35.746 47.9402 35.5024 48.3368 35.3998C54.2677 33.8811 60.4856 33.8811 66.4166 35.3998C66.8472 35.5128 67.2155 35.7917 67.4411 36.1755C67.6666 36.5593 67.731 37.0169 67.6202 37.448C67.5094 37.8792 67.2324 38.249 66.8498 38.4765C66.4671 38.704 66.0099 38.7708 65.5782 38.6622C60.1977 37.2849 54.5569 37.2849 49.1764 38.6622C49.039 38.6972 48.8977 38.7148 48.7559 38.7146V38.7146Z"
        fill="#000000"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls5"
        d="M60.0079 40.7017H54.7457C52.4526 40.7017 50.5938 42.5605 50.5938 44.8536V51.6765C50.5938 53.9696 52.4526 55.8285 54.7457 55.8285H60.0079C62.301 55.8285 64.1598 53.9696 64.1598 51.6765V44.8536C64.1598 42.5605 62.301 40.7017 60.0079 40.7017Z"
        fill="#0143AE"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls4"
        d="M83.9822 48.4548L78.5137 43.8662L69.1199 55.0612L74.5884 59.6498L83.9822 48.4548Z"
        fill="#127EFF"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls6"
        d="M75.237 42.993C74.9957 42.7897 74.8367 42.5054 74.7898 42.1933C74.7429 41.8812 74.8114 41.5628 74.9824 41.2975C75.1534 41.0323 75.4152 40.8385 75.7188 40.7524C76.0224 40.6663 76.347 40.6937 76.6318 40.8297C80.8819 42.8694 84.5495 45.9471 87.2961 49.7785C87.4004 49.9167 87.476 50.0744 87.5185 50.2423C87.5609 50.4102 87.5693 50.5849 87.5431 50.7561C87.517 50.9273 87.4568 51.0915 87.3662 51.2391C87.2756 51.3867 87.1564 51.5146 87.0155 51.6154C86.8747 51.7162 86.7151 51.7877 86.5462 51.8259C86.3773 51.864 86.2024 51.8679 86.032 51.8374C85.8615 51.8069 85.6989 51.7426 85.5536 51.6483C85.4084 51.5539 85.2836 51.4315 85.1864 51.2881C82.6937 47.8128 79.3666 45.0207 75.5115 43.1689C75.4129 43.1223 75.3206 43.0631 75.237 42.993V42.993Z"
        fill="#000000"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls5"
        d="M80.9479 49.7799L77.7348 47.0838C76.4121 45.974 74.4401 46.1465 73.3302 47.4692L69.8619 51.6026C68.752 52.9253 68.9245 54.8973 70.2473 56.0072L73.4603 58.7032C74.783 59.8131 76.755 59.6406 77.8649 58.3179L81.3332 54.1845C82.4431 52.8618 82.2706 50.8898 80.9479 49.7799Z"
        fill="#0143AE"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls4"
        d="M57.3748 106.494C74.831 106.494 88.982 92.3427 88.982 74.8865C88.982 57.4303 74.831 43.2793 57.3748 43.2793C39.9186 43.2793 25.7676 57.4303 25.7676 74.8865C25.7676 92.3427 39.9186 106.494 57.3748 106.494Z"
        fill="#127EFF"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls3"
        d="M57.3766 101.521C72.0863 101.521 84.011 89.5966 84.011 74.8868C84.011 60.1771 72.0863 48.2524 57.3766 48.2524C42.6668 48.2524 30.7422 60.1771 30.7422 74.8868C30.7422 89.5966 42.6668 101.521 57.3766 101.521Z"
        fill="#FFFFFF"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M57.375 53.0267V50.4966"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M57.375 99.2762V96.7461"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M46.4467 55.9552L45.1816 53.7632"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M69.5717 96.0086L68.3066 93.8179"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M38.4459 63.956L36.2539 62.6909"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M78.4993 87.0809L76.3086 85.8159"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M35.5177 74.8867H32.9863"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M81.7652 74.8867H79.2363"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M38.4459 85.8159L36.2539 87.0809"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M78.4993 62.6909L76.3086 63.956"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M46.4467 93.8164L45.1816 96.0084"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <path
        class="strokeCls1"
        d="M69.5717 53.7632L68.3066 55.9539"
        stroke="#000000"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
        style="animation-duration: 15s"
      ></path>
      <g class="watch7" style="animation-duration: 15s">
        <path
          class="strokeCls1"
          d="M57.375 74.8865V55.8286"
          stroke="#000000"
          stroke-width="2px"
          stroke-linecap="round"
          stroke-linejoin="round"
          style="animation-duration: 15s"
        ></path>
        <path
          class="strokeCls1"
          d="M59.1958 58.33L57.3756 55.8286L55.5566 58.33"
          stroke="#000000"
          stroke-width="2px"
          stroke-linecap="round"
          stroke-linejoin="round"
          style="animation-duration: 15s"
        ></path>
      </g>
      <path
        class="fillCls1"
        d="M41.987 47.2709C41.987 47.2709 34.6413 42.0435 29.2393 44.6285C22.7681 47.7262 21.2698 55.3252 26.4185 61.8013C31.5673 68.2775 35.4909 69.7421 40.027 66.6993C44.6081 63.6265 43.4154 55.9901 39.7027 48.6781L41.987 47.2709Z"
        fill="#FEB0A3"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls1"
        d="M23.4508 55.3452C19.7318 55.9129 15.2406 59.4223 14.9137 65.357C14.5868 71.2917 19.5597 76.4903 24.7595 79.1451C29.9594 81.8 36.5104 76 32.4945 67.3943C28.4785 58.7885 23.4508 55.3452 23.4508 55.3452Z"
        fill="#FEB0A3"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls1"
        d="M22.7131 76.5553C18.7857 77.8029 16.1309 83.6664 20.1693 89.4165C24.2076 95.1666 32.645 100.326 37.3496 93.6944C41.2445 88.2051 26.2537 76.085 26.2537 76.085L22.7131 76.5553Z"
        fill="#FEB0A3"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls2"
        d="M38.1359 59.1574L35.0594 54.4104C34.5017 53.5483 33.8355 52.6114 32.8275 52.4143C31.6348 52.1835 30.4883 53.1004 29.615 53.8115C28.9176 54.3759 28.2512 54.9777 27.6189 55.6143C27.2446 55.9885 26.8704 56.4165 26.7993 56.9417C26.7356 57.4133 26.9327 57.8774 27.1411 58.304C28.3708 60.8098 30.1484 63.007 32.3422 64.7328C32.7033 65.0241 33.1358 65.2133 33.5948 65.2809C34.0537 65.3485 34.5224 65.2919 34.9521 65.117C35.0308 65.0844 35.1067 65.0456 35.1792 65.001C36.0146 64.472 36.8205 63.8976 37.5932 63.2806C38.1808 62.8115 38.7847 62.2588 38.9231 61.5203C39.0841 60.6832 38.6 59.8722 38.1359 59.1574Z"
        fill="#BB6458"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls2"
        d="M29.1598 71.5713L26.1257 68.0232C25.5742 67.3782 24.928 66.6845 24.0821 66.6346C23.0841 66.576 22.242 67.4505 21.6057 68.1317C21.0971 68.6696 20.6182 69.2347 20.171 69.8247C19.9078 70.1727 19.6458 70.562 19.6445 70.9986C19.6445 71.3916 19.8566 71.7472 20.0737 72.0765C21.3521 73.9928 23.0453 75.5968 25.0278 76.7699C25.3554 76.9685 25.7301 77.0758 26.1132 77.0806C26.4962 77.0854 26.8736 76.9876 27.2061 76.7974C27.2672 76.7605 27.3251 76.7188 27.3795 76.6726C28.0051 76.1484 28.6019 75.5908 29.1672 75.0021C29.5964 74.5542 30.0306 74.0377 30.063 73.4177C30.1004 72.7165 29.6164 72.1065 29.1598 71.5713Z"
        fill="#BB6458"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls2"
        d="M33.4569 88.9546L30.2744 86.1775C29.6968 85.6785 29.0268 85.1371 28.2633 85.2044C27.3601 85.283 26.725 86.1763 26.2435 86.8662C25.8598 87.4145 25.5058 87.983 25.183 88.5691C24.9922 88.916 24.8088 89.299 24.8662 89.6919C24.9173 90.0438 25.1543 90.3357 25.3914 90.6002C26.7878 92.1467 28.5142 93.3593 30.4428 94.1483C30.7619 94.2831 31.1112 94.33 31.4546 94.2841C31.7979 94.2383 32.1227 94.1013 32.3952 93.8875C32.4447 93.8493 32.4914 93.8076 32.535 93.7628C33.0258 93.2113 33.4864 92.6337 33.9148 92.0324C34.2404 91.5758 34.561 91.0556 34.5086 90.4966C34.455 89.8554 33.9372 89.3726 33.4569 88.9546Z"
        fill="#BB6458"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls2"
        d="M95.5121 33.2573C95.6399 33.2223 95.765 33.1781 95.8864 33.1251C93.1268 30.3617 90.1638 27.7905 87.6125 26.1387C87.4391 26.781 87.4906 27.4634 87.7585 28.0724C88.119 28.9245 88.7715 29.6132 89.4115 30.2806C90.2349 31.1414 91.0708 32.0122 92.0925 32.6248C93.1143 33.2373 94.3631 33.568 95.5121 33.2573Z"
        fill="#BB6458"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
      <path
        class="fillCls1"
        d="M93.9052 62.356C93.9052 62.356 86.9001 72.1145 86.6381 79.7933C86.3761 87.4721 86.4372 92.9726 89.5487 102.432C92.6601 111.891 104.858 89.7451 104.858 89.7451L93.9052 62.356Z"
        fill="#FEB0A3"
        stroke-width="2px"
        style="animation-duration: 15s"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "StrappWatch7",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
.watch7 {
  animation: watch7 15s infinite linear;
  transform-origin: 57.38px 75.38px;
}
@keyframes watch7 {
  100% {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .watch7 {
    animation: none;
  }
}
</style>
